var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Point, Rectangle } from '../../geometry';
import { Platform, NumberExt, ObjectExt, Dom } from '../../util';
import { View } from '../../view/view';
import { GraphView } from '../../graph/view';
import { BackgroundManager } from '../../graph/background';
export class Scroller extends View {
    constructor(options) {
        super();
        this.padding = { left: 0, top: 0, right: 0, bottom: 0 };
        this.options = Util.getOptions(options);
        const scale = this.graph.scale();
        this.sx = scale.sx;
        this.sy = scale.sy;
        const width = this.options.width || this.graph.options.width;
        const height = this.options.height || this.graph.options.height;
        this.container = document.createElement('div');
        this.$container = this.$(this.container)
            .addClass(this.prefixClassName(Util.containerClass))
            .css({ width, height });
        if (this.options.pageVisible) {
            this.$container.addClass(this.prefixClassName(Util.pagedClass));
        }
        if (this.options.className) {
            this.$container.addClass(this.options.className);
        }
        const graph = this.graph;
        const graphContaoner = graph.container;
        if (graphContaoner.parentNode) {
            this.$container.insertBefore(graphContaoner);
        }
        this.content = document.createElement('div');
        this.$content = this.$(this.content)
            .addClass(this.prefixClassName(Util.contentClass))
            .css({
            width: graph.options.width,
            height: graph.options.height,
        });
        // custom background
        if (this.options.background) {
            this.background = document.createElement('div');
            this.$background = this.$(this.background).addClass(this.prefixClassName(Util.backgroundClass));
            this.$content.append(this.background);
        }
        if (!this.options.pageVisible) {
            this.$content.append(this.graph.view.background);
            this.$content.append(this.graph.view.grid);
        }
        this.$content.append(graphContaoner);
        this.$content.appendTo(this.container);
        this.startListening();
        this.setCursor(this.options.cursor);
        if (!this.options.pageVisible) {
            this.graph.grid.update();
            this.graph.background.update();
        }
        this.backgroundManager = new Scroller.Background(this);
    }
    get graph() {
        return this.options.graph;
    }
    get model() {
        return this.graph.model;
    }
    startListening() {
        const graph = this.graph;
        const model = this.model;
        graph.on('scale', this.onScale, this);
        graph.on('resize', this.onResize, this);
        graph.on('before:print', this.storeScrollPosition, this);
        graph.on('before:export', this.storeScrollPosition, this);
        graph.on('after:print', this.restoreScrollPosition, this);
        graph.on('after:export', this.restoreScrollPosition, this);
        if (this.options.autoResize) {
            if (graph.renderer.isAsync()) {
                graph.on('render:done', this.onRenderDone, this);
            }
            else {
                model.on('reseted', this.update, this);
                model.on('cell:added', this.update, this);
                model.on('cell:removed', this.update, this);
                model.on('cell:changed', this.update, this);
            }
        }
        this.delegateBackgroundEvents();
    }
    stopListening() {
        const graph = this.graph;
        const model = this.model;
        graph.off('scale', this.onScale, this);
        graph.off('resize', this.onResize, this);
        graph.off('beforeprint', this.storeScrollPosition, this);
        graph.off('beforeexport', this.storeScrollPosition, this);
        graph.off('afterprint', this.restoreScrollPosition, this);
        graph.off('afterexport', this.restoreScrollPosition, this);
        graph.off('render:done', this.onRenderDone, this);
        model.off('reseted', this.update, this);
        model.off('cell:added', this.update, this);
        model.off('cell:removed', this.update, this);
        model.off('cell:changed', this.update, this);
        this.undelegateBackgroundEvents();
    }
    delegateBackgroundEvents(events) {
        const evts = events || GraphView.events;
        this.delegatedHandlers = Object.keys(evts).reduce((memo, name) => {
            const handler = evts[name];
            if (name.indexOf(' ') === -1) {
                if (typeof handler === 'function') {
                    memo[name] = handler;
                }
                else {
                    let method = this.graph.view[handler];
                    if (typeof method === 'function') {
                        method = method.bind(this.graph.view);
                        memo[name] = method;
                    }
                }
            }
            return memo;
        }, {});
        this.onBackgroundEvent = this.onBackgroundEvent.bind(this);
        Object.keys(this.delegatedHandlers).forEach((name) => {
            this.delegateEvent(name, {
                guarded: false,
            }, this.onBackgroundEvent);
        });
    }
    undelegateBackgroundEvents() {
        Object.keys(this.delegatedHandlers).forEach((name) => {
            this.undelegateEvent(name, this.onBackgroundEvent);
        });
    }
    onBackgroundEvent(e) {
        let shouldHnadleEvent = false;
        const target = e.target;
        if (!this.options.pageVisible) {
            shouldHnadleEvent =
                this.graph.view.background === target || this.graph.view.grid === target;
        }
        else if (this.options.background) {
            shouldHnadleEvent = this.background === target;
        }
        else {
            shouldHnadleEvent = this.content === target;
        }
        if (shouldHnadleEvent) {
            const handler = this.delegatedHandlers[e.type];
            if (typeof handler === 'function') {
                handler.apply(this.graph, arguments);
            }
        }
    }
    onRenderDone({ stats }) {
        if (stats.priority < 2) {
            this.update();
        }
    }
    onResize() {
        if (this.cachedCenterPoint) {
            this.centerPoint(this.cachedCenterPoint.x, this.cachedCenterPoint.y);
            this.updatePageBreak();
        }
    }
    onScale({ sx, sy, ox, oy }) {
        this.updateScale(sx, sy);
        this.sx = sx;
        this.sy = sy;
        if (ox || oy) {
            this.centerPoint(ox, oy);
            this.updatePageBreak();
        }
        if (typeof this.options.fitTocontentOptions === 'function') {
            this.update();
        }
    }
    storeScrollPosition() {
        this.cachedScrollLeft = this.container.scrollLeft;
        this.cachedScrollTop = this.container.scrollTop;
    }
    restoreScrollPosition() {
        this.container.scrollLeft = this.cachedScrollLeft;
        this.container.scrollTop = this.cachedScrollTop;
        this.cachedScrollLeft = null;
        this.cachedScrollTop = null;
    }
    beforeManipulation() {
        if (Platform.IS_IE || Platform.IS_EDGE) {
            this.$container.css('visibility', 'hidden');
        }
    }
    afterManipulation() {
        if (Platform.IS_IE || Platform.IS_EDGE) {
            this.$container.css('visibility', 'visible');
        }
    }
    updatePageBreak() {
        if (this.pageBreak && this.pageBreak.parentNode) {
            this.pageBreak.parentNode.removeChild(this.pageBreak);
        }
        const options = this.options;
        if (options.pageVisible && options.pageBreak) {
            const graphWidth = this.graph.options.width;
            const graphHeight = this.graph.options.height;
            const pageWidth = options.pageWidth || graphWidth;
            const pageHeight = options.pageHeight || graphHeight;
            if (graphWidth > pageWidth || graphHeight > pageHeight) {
                this.pageBreak = document.createElement('div');
                Dom.addClass(this.pageBreak, this.prefixClassName('graph-pagebreak'));
                this.$(this.graph.view.grid).after(this.pageBreak);
                for (let i = 1, l = Math.floor(graphWidth / pageWidth); i < l; i += 1) {
                    this.$('<div/>')
                        .addClass(this.prefixClassName(`graph-pagebreak-vertical`))
                        .css({
                        left: i * pageWidth,
                    })
                        .appendTo(this.pageBreak);
                }
                for (let i = 1, l = Math.floor(graphHeight / pageHeight); i < l; i += 1) {
                    this.$('<div/>')
                        .addClass(this.prefixClassName(`graph-pagebreak-horizontal`))
                        .css({
                        top: i * pageHeight,
                    })
                        .appendTo(this.pageBreak);
                }
            }
        }
    }
    update() {
        const size = this.getClientSize();
        this.cachedCenterPoint = this.clientToLocalPoint(size.width / 2, size.height / 2);
        let fitTocontentOptions = this.options.fitTocontentOptions;
        if (typeof fitTocontentOptions === 'function') {
            fitTocontentOptions = fitTocontentOptions.call(this, this);
        }
        const options = Object.assign({ gridWidth: this.options.pageWidth, gridHeight: this.options.pageHeight, allowNewOrigin: 'negative' }, fitTocontentOptions);
        this.graph.fitToContent(this.getFitToContentOptions(options));
    }
    getFitToContentOptions(options) {
        const sx = this.sx;
        const sy = this.sy;
        options.gridWidth && (options.gridWidth *= sx);
        options.gridHeight && (options.gridHeight *= sy);
        options.minWidth && (options.minWidth *= sx);
        options.minHeight && (options.minHeight *= sy);
        if (typeof options.padding === 'object') {
            options.padding = {
                left: (options.padding.left || 0) * sx,
                right: (options.padding.right || 0) * sx,
                top: (options.padding.top || 0) * sy,
                bottom: (options.padding.bottom || 0) * sy,
            };
        }
        else if (typeof options.padding === 'number') {
            options.padding = options.padding * sx;
        }
        return options;
    }
    updateScale(sx, sy) {
        const options = this.graph.options;
        const dx = sx / this.sx;
        const dy = sy / this.sy;
        this.graph.setOrigin(options.x * dx, options.y * dy);
        this.graph.resize(options.width * dx, options.height * dy);
    }
    scrollbarPosition(left, top, options) {
        if (left == null && top == null) {
            return {
                left: this.container.scrollLeft,
                top: this.container.scrollTop,
            };
        }
        const prop = {};
        if (typeof left === 'number') {
            prop.scrollLeft = left;
        }
        if (typeof top === 'number') {
            prop.scrollTop = top;
        }
        if (options && options.animation) {
            this.$container.animate(prop, options.animation);
        }
        else {
            this.$container.prop(prop);
        }
        return this;
    }
    /**
     * Try to scroll to ensure that the position (x,y) on the graph (in local
     * coordinates) is at the center of the viewport. If only one of the
     * coordinates is specified, only scroll in the specified dimension and
     * keep the other coordinate unchanged.
     */
    scrollToPoint(x, y, options) {
        const size = this.getClientSize();
        const ctm = this.graph.matrix();
        const prop = {};
        if (typeof x === 'number') {
            prop.scrollLeft = x - size.width / 2 + ctm.e + (this.padding.left || 0);
        }
        if (typeof y === 'number') {
            prop.scrollTop = y - size.height / 2 + ctm.f + (this.padding.top || 0);
        }
        if (options && options.animation) {
            this.$container.animate(prop, options.animation);
        }
        else {
            this.$container.prop(prop);
        }
        return this;
    }
    /**
     * Try to scroll to ensure that the center of graph content is at the
     * center of the viewport.
     */
    scrollToContent(options) {
        const sx = this.sx;
        const sy = this.sy;
        const center = this.graph.getContentArea().getCenter();
        return this.scrollToPoint(center.x * sx, center.y * sy, options);
    }
    /**
     * Try to scroll to ensure that the center of cell is at the center of
     * the viewport.
     */
    scrollToCell(cell, options) {
        const sx = this.sx;
        const sy = this.sy;
        const center = cell.getBBox().getCenter();
        return this.scrollToPoint(center.x * sx, center.y * sy, options);
    }
    /**
     * The center methods are more aggressive than the scroll methods. These
     * methods position the graph so that a specific point on the graph lies
     * at the center of the viewport, adding paddings around the paper if
     * necessary (e.g. if the requested point lies in a corner of the paper).
     * This means that the requested point will always move into the center
     * of the viewport. (Use the scroll functions to avoid adding paddings
     * and only scroll the viewport as far as the graph boundary.)
     */
    /**
     * Position the center of graph to the center of the viewport.
     */
    center(optons) {
        return this.centerPoint(optons);
    }
    centerPoint(x, y, options) {
        const ctm = this.graph.matrix();
        const sx = ctm.a;
        const sy = ctm.d;
        const tx = -ctm.e;
        const ty = -ctm.f;
        const tWidth = tx + this.graph.options.width;
        const tHeight = ty + this.graph.options.height;
        let localOptions;
        if (typeof x === 'number' || typeof y === 'number') {
            localOptions = options;
            const visibleCenter = this.getVisibleArea().getCenter();
            if (typeof x === 'number') {
                x = x * sx; // tslint:disable-line
            }
            else {
                x = visibleCenter.x; // tslint:disable-line
            }
            if (typeof y === 'number') {
                y = y * sy; // tslint:disable-line
            }
            else {
                y = visibleCenter.y; // tslint:disable-line
            }
        }
        else {
            localOptions = x;
            x = (tx + tWidth) / 2; // tslint:disable-line
            y = (ty + tHeight) / 2; // tslint:disable-line
        }
        if (localOptions && localOptions.padding) {
            return this.positionPoint({ x, y }, '50%', '50%', localOptions);
        }
        const padding = this.getPadding();
        const clientSize = this.getClientSize();
        const cx = clientSize.width / 2;
        const cy = clientSize.height / 2;
        const left = cx - padding.left - x + tx;
        const right = cx - padding.right + x - tWidth;
        const top = cy - padding.top - y + ty;
        const bottom = cy - padding.bottom + y - tHeight;
        this.addPadding(Math.max(left, 0), Math.max(right, 0), Math.max(top, 0), Math.max(bottom, 0));
        return this.scrollToPoint(x, y, localOptions || undefined);
    }
    centerContent(options) {
        return this.positionContent('center', options);
    }
    centerCell(cell, options) {
        return this.positionCell(cell, 'center', options);
    }
    /**
     * The position methods are a more general version of the center methods.
     * They position the graph so that a specific point on the graph lies at
     * requested coordinates inside the viewport.
     */
    /**
     *
     */
    positionContent(pos, options) {
        const rect = this.graph.getContentArea(options);
        return this.positionRect(rect, pos, options);
    }
    positionCell(cell, pos, options) {
        const bbox = cell.getBBox();
        return this.positionRect(bbox, pos, options);
    }
    positionRect(rect, pos, options) {
        const bbox = Rectangle.create(rect);
        switch (pos) {
            case 'center':
                return this.positionPoint(bbox.getCenter(), '50%', '50%', options);
            case 'top':
                return this.positionPoint(bbox.getTopCenter(), '50%', 0, options);
            case 'top-right':
                return this.positionPoint(bbox.getTopRight(), '100%', 0, options);
            case 'right':
                return this.positionPoint(bbox.getRightMiddle(), '100%', '50%', options);
            case 'bottom-right':
                return this.positionPoint(bbox.getBottomRight(), '100%', '100%', options);
            case 'bottom':
                return this.positionPoint(bbox.getBottomCenter(), '50%', '100%', options);
            case 'bottom-left':
                return this.positionPoint(bbox.getBottomLeft(), 0, '100%', options);
            case 'left':
                return this.positionPoint(bbox.getLeftMiddle(), 0, '50%', options);
            case 'top-left':
                return this.positionPoint(bbox.getTopLeft(), 0, 0, options);
            default:
                return this;
        }
    }
    positionPoint(point, x, y, options = {}) {
        const { padding: pad } = options, localOptions = __rest(options, ["padding"]);
        const padding = NumberExt.normalizeSides(pad);
        const clientRect = Rectangle.fromSize(this.getClientSize());
        const targetRect = clientRect.clone().moveAndExpand({
            x: padding.left,
            y: padding.top,
            width: -padding.right - padding.left,
            height: -padding.top - padding.bottom,
        });
        // tslint:disable-next-line
        x = NumberExt.normalizePercentage(x, Math.max(0, targetRect.width));
        if (x < 0) {
            x = targetRect.width + x; // tslint:disable-line
        }
        // tslint:disable-next-line
        y = NumberExt.normalizePercentage(y, Math.max(0, targetRect.height));
        if (y < 0) {
            y = targetRect.height + y; // tslint:disable-line
        }
        const origin = targetRect.getTopLeft().translate(x, y);
        const diff = clientRect.getCenter().diff(origin);
        const scale = this.zoom();
        const rawDiff = diff.scale(1 / scale, 1 / scale);
        const result = Point.create(point).translate(rawDiff);
        return this.centerPoint(result.x, result.y, localOptions);
    }
    zoom(factor, options) {
        if (factor == null) {
            return this.sx;
        }
        options = options || {}; // tslint:disable-line
        let cx;
        let cy;
        const clientSize = this.getClientSize();
        const center = this.clientToLocalPoint(clientSize.width / 2, clientSize.height / 2);
        let sx = factor;
        let sy = factor;
        if (!options.absolute) {
            sx = sx + this.sx;
            sy = sy + this.sy;
        }
        if (options.scaleGrid) {
            sx = Math.round(sx / options.scaleGrid) * options.scaleGrid;
            sy = Math.round(sy / options.scaleGrid) * options.scaleGrid;
        }
        if (options.maxScale) {
            sx = Math.min(options.maxScale, sx);
            sy = Math.min(options.maxScale, sy);
        }
        if (options.minScale) {
            sx = Math.max(options.minScale, sx);
            sy = Math.max(options.minScale, sy);
        }
        sx = this.graph.transform.clampScale(sx);
        sy = this.graph.transform.clampScale(sy);
        if (options.center) {
            const fx = sx / this.sx;
            const fy = sy / this.sy;
            cx = options.center.x - (options.center.x - center.x) / fx;
            cy = options.center.y - (options.center.y - center.y) / fy;
        }
        else {
            cx = center.x;
            cy = center.y;
        }
        this.beforeManipulation();
        this.graph.transform.scale(sx, sy);
        this.centerPoint(cx, cy);
        this.afterManipulation();
        return this;
    }
    zoomToRect(rect, options = {}) {
        const area = Rectangle.create(rect);
        const graph = this.graph;
        const origin = { x: graph.options.x, y: graph.options.y };
        options.contentArea = area;
        if (options.fittingBBox == null) {
            options.fittingBBox = Object.assign(Object.assign({}, origin), { width: this.$container.width(), height: this.$container.height() });
        }
        this.beforeManipulation();
        graph.scaleContentToFit(options);
        const center = area.getCenter();
        this.centerPoint(center.x, center.y);
        this.afterManipulation();
        return this;
    }
    zoomToFit(options = {}) {
        return this.zoomToRect(this.graph.getContentArea(options), options);
    }
    transitionToPoint(x, y, options) {
        if (typeof x === 'object') {
            options = y; // tslint:disable-line
            y = x.y; // tslint:disable-line
            x = x.x; // tslint:disable-line
        }
        else {
            y = y; // tslint:disable-line
        }
        if (options == null) {
            options = {}; // tslint:disable-line
        }
        let transform;
        let transformOrigin;
        const scale = this.sx;
        const targetScale = Math.max(options.scale || scale, 0.000001);
        const clientSize = this.getClientSize();
        const targetPoint = new Point(x, y);
        const localPoint = this.clientToLocalPoint(clientSize.width / 2, clientSize.height / 2);
        if (scale === targetScale) {
            const translate = localPoint.diff(targetPoint).scale(scale, scale).round();
            transform = `translate(${translate.x}px,${translate.y}px)`;
        }
        else {
            const delta = (targetScale / (scale - targetScale)) * targetPoint.distance(localPoint);
            const range = localPoint.clone().move(targetPoint, delta);
            const origin = this.localToBackgroundPoint(range).round();
            transform = `scale(${targetScale / scale})`;
            transformOrigin = `${origin.x}px ${origin.y}px`;
        }
        const onTransitionEnd = options.onTransitionEnd;
        this.$container.addClass(Util.transitionClassName);
        this.$content
            .off(Util.transitionEventName)
            .on(Util.transitionEventName, (e) => {
            this.syncTransition(targetScale, { x: x, y: y });
            if (typeof onTransitionEnd === 'function') {
                onTransitionEnd.call(this, e);
            }
        })
            .css({
            transform,
            transformOrigin,
            transition: 'transform',
            transitionDuration: options.duration || '1s',
            transitionDelay: options.delay,
            transitionTimingFunction: options.timingFunction,
        });
        return this;
    }
    syncTransition(scale, p) {
        this.beforeManipulation();
        this.graph.scale(scale);
        this.removeTransition();
        this.centerPoint(p.x, p.y);
        this.afterManipulation();
        return this;
    }
    removeTransition() {
        this.$container.removeClass(Util.transitionClassName);
        this.$content.off(Util.transitionEventName).css({
            transform: '',
            transformOrigin: '',
            transition: '',
            transitionDuration: '',
            transitionDelay: '',
            transitionTimingFunction: '',
        });
        return this;
    }
    transitionToRect(rectangle, options = {}) {
        const rect = Rectangle.create(rectangle);
        const maxScale = options.maxScale || Infinity;
        const minScale = options.minScale || Number.MIN_VALUE;
        const scaleGrid = options.scaleGrid || null;
        const PIXEL_SIZE = options.visibility || 1;
        const center = options.center
            ? Point.create(options.center)
            : rect.getCenter();
        const clientSize = this.getClientSize();
        const w = clientSize.width * PIXEL_SIZE;
        const h = clientSize.height * PIXEL_SIZE;
        let scale = new Rectangle(center.x - w / 2, center.y - h / 2, w, h).maxRectUniformScaleToFit(rect, center);
        scale = Math.min(scale, maxScale);
        if (scaleGrid) {
            scale = Math.floor(scale / scaleGrid) * scaleGrid;
        }
        scale = Math.max(minScale, scale);
        return this.transitionToPoint(center, Object.assign({ scale }, options));
    }
    startPanning(evt) {
        const e = this.normalizeEvent(evt);
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.$container.addClass(this.prefixClassName(Util.panningClass));
        this.trigger('pan:start', { e });
        this.$(document.body).on({
            'mousemove.panning touchmove.panning': this.pan.bind(this),
            'mouseup.panning touchend.panning': this.stopPanning.bind(this),
        });
        this.$(window).on('mouseup.panning', this.stopPanning.bind(this));
    }
    pan(evt) {
        const e = this.normalizeEvent(evt);
        const dx = e.clientX - this.clientX;
        const dy = e.clientY - this.clientY;
        this.container.scrollTop -= dy;
        this.container.scrollLeft -= dx;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
    }
    stopPanning(e) {
        this.$(document.body).off('.panning');
        this.$(window).off('.panning');
        this.$container.removeClass(this.prefixClassName(Util.panningClass));
        this.trigger('pan:stop', { e });
    }
    clientToLocalPoint(a, b) {
        let x = typeof a === 'object' ? a.x : a;
        let y = typeof a === 'object' ? a.y : b;
        const ctm = this.graph.matrix();
        x += this.container.scrollLeft - this.padding.left - ctm.e;
        y += this.container.scrollTop - this.padding.top - ctm.f;
        return new Point(x / ctm.a, y / ctm.d);
    }
    localToBackgroundPoint(x, y) {
        const p = typeof x === 'object' ? Point.create(x) : new Point(x, y);
        const ctm = this.graph.matrix();
        const padding = this.padding;
        return Dom.transformPoint(p, ctm).translate(padding.left, padding.top);
    }
    getClientSize() {
        return {
            width: this.container.clientWidth,
            height: this.container.clientHeight,
        };
    }
    addPadding(left, right, top, bottom) {
        let padding = this.getPadding();
        this.padding = {
            left: Math.round(padding.left + (left || 0)),
            top: Math.round(padding.top + (top || 0)),
            bottom: Math.round(padding.bottom + (bottom || 0)),
            right: Math.round(padding.right + (right || 0)),
        };
        padding = this.padding;
        this.$content.css({
            width: padding.left + this.graph.options.width + padding.right,
            height: padding.top + this.graph.options.height + padding.bottom,
        });
        const container = this.graph.container;
        container.style.left = `${this.padding.left}px`;
        container.style.top = `${this.padding.top}px`;
        return this;
    }
    getPadding() {
        const padding = this.options.padding;
        if (typeof padding === 'function') {
            return NumberExt.normalizeSides(padding.call(this));
        }
        return NumberExt.normalizeSides(padding);
    }
    /**
     * Returns the untransformed size and origin of the current viewport.
     */
    getVisibleArea() {
        const ctm = this.graph.matrix();
        const size = this.getClientSize();
        const box = {
            x: this.container.scrollLeft || 0,
            y: this.container.scrollTop || 0,
            width: size.width,
            height: size.height,
        };
        const area = Dom.transformRectangle(box, ctm.inverse());
        area.x -= (this.padding.left || 0) / this.sx;
        area.y -= (this.padding.top || 0) / this.sy;
        return area;
    }
    isCellVisible(cell, options = {}) {
        const bbox = cell.getBBox();
        const area = this.getVisibleArea();
        return options.strict ? area.containsRect(bbox) : area.isIntersectWith(bbox);
    }
    isPointVisible(point) {
        return this.getVisibleArea().containsPoint(point);
    }
    /**
     * Lock the current viewport by disabling user scrolling.
     */
    lock() {
        this.$container.css('overflow', 'hidden');
        return this;
    }
    /**
     * Enable user scrolling if previously locked.
     */
    unlock() {
        this.$container.css('overflow', 'scroll');
        return this;
    }
    setCursor(value, options = {}) {
        this.$container.css('cursor', value || '');
        if (options.silent !== true) {
            this.options.cursor = value;
        }
    }
    onRemove() {
        this.stopListening();
    }
    dispose() {
        this.$(this.graph.container).insertBefore(this.$container);
        this.remove();
    }
}
__decorate([
    View.dispose()
], Scroller.prototype, "dispose", null);
(function (Scroller) {
    class Background extends BackgroundManager {
        constructor(scroller) {
            super(scroller.graph);
            this.scroller = scroller;
            if (scroller.options.background) {
                this.draw(scroller.options.background);
            }
        }
        get elem() {
            return this.scroller.background;
        }
        get container() {
            return this.scroller.content;
        }
        init() {
            this.graph.on('scale', this.update, this);
            this.graph.on('translate', this.update, this);
        }
    }
    Scroller.Background = Background;
})(Scroller || (Scroller = {}));
var Util;
(function (Util) {
    Util.containerClass = 'graph-scroller';
    Util.panningClass = `${Util.containerClass}-panning`;
    Util.pagedClass = `${Util.containerClass}-paged`;
    Util.contentClass = `${Util.containerClass}-content`;
    Util.backgroundClass = `${Util.containerClass}-background`;
    Util.transitionClassName = 'transition-in-progress';
    Util.transitionEventName = 'transitionend.graph-scroller-transition';
    Util.defaultOptions = {
        padding() {
            const size = this.getClientSize();
            const minWidth = Math.max(this.options.minVisibleWidth || 0, 1) || 1;
            const minHeight = Math.max(this.options.minVisibleHeight || 0, 1) || 1;
            const left = Math.max(size.width - minWidth, 0);
            const top = Math.max(size.height - minHeight, 0);
            return { left, top, right: left, bottom: top };
        },
        minVisibleWidth: 50,
        minVisibleHeight: 50,
        pageVisible: false,
        pageBreak: false,
        autoResize: true,
    };
    function getOptions(options) {
        const merged = ObjectExt.merge({}, Util.defaultOptions, options);
        const graph = options.graph;
        if (merged.pageWidth == null) {
            merged.pageWidth = graph.options.width;
        }
        if (merged.pageHeight == null) {
            merged.pageHeight = graph.options.height;
        }
        return merged;
    }
    Util.getOptions = getOptions;
})(Util || (Util = {}));
//# sourceMappingURL=index.js.map